<template>
  <section class="all_emp card_style">
    <div class="d-flex align-items-center gap-3 mb-2">
      <AddFavDailog v-tooltip.left="$t('add_to_favourite')" />
      <h4 class="mb-0">{{ $t("the_groups") }}</h4>
    </div>

    <!-- search -->
    <div class="main_header_style mb-2">
      <input
        type="text"
        v-model="GroupsText"
        @keyup="fetchGroups(1)"
        class="form-control w-50"
        :placeholder="$t('search...')"
      />
    </div>

    <!-- table -->
    <div class="row">
      <div class="table-responsive">
        <table class="table Groups">
          <thead>
            <tr>
              <th>{{ $t("ID") }}</th>
              <th>{{ $t("name") }}</th>
              <th>{{ $t("room_title") }}</th>
              <th>{{ $t("created_at") }}</th>
              <th>{{ $t("from") }}</th>
              <th>{{ $t("to") }}</th>
              <th>{{ $t("hotel") }}</th>
              <th>{{ $t("Control") }}</th>
            </tr>
          </thead>

          <!-- skeleton loader -->
          <tbody v-if="loading" class="text-center">
            <tr v-for="i in 10" :key="i">
              <td v-for="j in 7" :key="j">
                <Skeleton height="2rem" width="90%" class="mb-2" />
              </td>
            </tr>
          </tbody>

          <!-- real data -->
          <tbody v-else>
            <tr v-for="(group, index) in Groups.data" :key="group.id">
              <td>{{ group?.id }}</td>
              <td>{{ group?.title }}</td>
              <td>{{ group?.hotel_room_view?.room?.title }}</td>
              <td>
                {{ new Date(group?.created_at).toLocaleDateString() }}
              </td>
              <td>
                {{ group?.days[0]?.day }}
              </td>
              <td>
                {{ group?.days[group?.days?.length - 1]?.day }}
              </td>
              <td>
                {{ group?.hotel?.title }}
              </td>
              <td>
                <button
                  class="btn btn-danger mx-1 w-auto"
                  @click="deleteGroups(group.id, index)"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </td>
            </tr>
            <tr v-if="Groups.data.length === 0">
              <td colspan="5" class="text-center">
                {{ $t("no_data_found") }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- pagination -->
    <div class="row">
      <pagination
        :data="Groups"
        class="mx-auto d-flex align-items-center justify-content-center pagination"
        @pagination-change-page="fetchGroups"
      >
        <template v-slot:prev-nav>&lt;</template>
        <template v-slot:next-nav>&gt;</template>
      </pagination>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import Swal from "sweetalert2";
import AddFavDailog from "@/components/layout/addFavDailog.vue";
import Skeleton from "primevue/skeleton";

export default {
  name: "GroupsWebsite",
  data() {
    return {
      Groups: { data: [] }, // تأكد انه كائن عشان مايحصلش error
      GroupsText: "",
      loading: true,
      type: this.$route.params.type,
    };
  },
  components: {
    pagination,
    AddFavDailog,
    Skeleton,
  },
  methods: {
    async fetchGroups(page = 1) {
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append("word", this.GroupsText);
        formData.append("season_rate_code_id", this.$route.params.rate_id);
        formData.append("page", page);

        const { data } = await axios.post(`/fetch_rate_code_group`, formData);
        this.Groups = data.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async deleteGroups(GroupsId, index) {
      const result = await Swal.fire({
        title: this.$t("check_delete"),
        text: this.$t("are_you_sure_delete"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: this.$t("back"),
        confirmButtonText: this.$t("confirm_delete"),
      });

      if (result.isConfirmed) {
        try {
          const { data } = await axios.post(`/delete_rate_code_group`, {
            group_id: GroupsId,
          });

          if (data.status) {
            Swal.fire("", data.message, "success");
            this.Groups.data.splice(index, 1);
          } else {
            Swal.fire("", data.message, "error");
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
  },
  mounted() {
    this.fetchGroups();
  },
};
</script>

<style scoped>
table tbody tr td img {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
</style>
